import { modalActions, userActions } from '@/actions';
import { showNavigationDrawer } from '@/actions/navigationDrawerActions';
import { EVENT_NAME, SCREEN_NAME } from '@/constants/analytics';
import { NAVIGATION_TRIGGER, NavigationTrigger } from '@/constants/navigation';
import { isServer, trackMpEvent, url } from '@/helpers';
import { TriggerSource } from '@/types/analytics';
import { NavItemIdentifier } from '@/types/navigation';
import { Dispatch } from 'redux';
import { z } from 'zod';

const screenNameSchema = z.enum(
  Object.values(SCREEN_NAME) as [
    (typeof SCREEN_NAME)[keyof typeof SCREEN_NAME],
    ...(typeof SCREEN_NAME)[keyof typeof SCREEN_NAME][],
  ],
);

export const handleLogoutClick = async (dispatch: Dispatch<any>, triggerSource: NavigationTrigger | TriggerSource) => {
  trackMpEvent(EVENT_NAME.LOGOUT_LOGGED_OUT, { screen_name: SCREEN_NAME.HOME, initiated_from: triggerSource });
  dispatch(userActions.logout());
};

export const handleLoginClick = async (
  dispatch: Dispatch<any>,
  identifier?: NavItemIdentifier,
  screenName?: string,
  triggerSource?: string,
) => {
  if (!isServer) {
    const hasValidTriggerSource = Object.values(NAVIGATION_TRIGGER).includes(triggerSource as NavigationTrigger);

    let loginTriggerSource: TriggerSource;
    if (triggerSource && hasValidTriggerSource) {
      loginTriggerSource = triggerSource as TriggerSource;
    } else {
      const validLoginScreenNames = screenNameSchema.safeParse(screenName);
      if (validLoginScreenNames.success) {
        loginTriggerSource = validLoginScreenNames.data;
      }
    }

    dispatch(
      modalActions.login({
        show: true,
        ...(loginTriggerSource ? { triggerSource: loginTriggerSource } : {}),
      }),
    );
  }
};

const handleHamburgerClick = (dispatch) => {
  dispatch(showNavigationDrawer({ show: true }));
};

export const handleNavItemClicked =
  (dispatch: Dispatch<any>, screenName, triggerSource = 'header_menu') =>
  (identifier: NavItemIdentifier) =>
  () => {
    if (identifier === NavItemIdentifier.Logout) return handleLogoutClick(dispatch, screenName);
    if (identifier === NavItemIdentifier.LogIn)
      return handleLoginClick(dispatch, identifier, screenName, triggerSource);
    if (identifier === NavItemIdentifier.Hamburger) return handleHamburgerClick(dispatch);
  };

export const getScreenName = (propSource?: string) => {
  const source = propSource ?? 'outside';
  return source === 'list' || source === 'mapview'
    ? `search_results${source === 'list' ? '' : '_map'}`
    : isServer
    ? ''
    : url.getScreenNameFromUrl(window?.location?.href);
};
